export class WebhookV1ClassificationJobFailedArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "startTime",
            "baseName": "startTime",
            "type": "WebhookV1ProtobufTimestamp",
            "format": ""
        },
        {
            "name": "endTime",
            "baseName": "endTime",
            "type": "WebhookV1ProtobufTimestamp",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1ClassificationJobFailedArguments.attributeTypeMap;
    }
    constructor() {
    }
}
